module.exports = __webpack_public_path__ + "img/kf-large-icon.120e6b7a.png";